<template>
	<v-app :key="i18n.locale">
		<div class="d-flex h-100">
			<!-- Header -->
			<v-app-bar class="hidden-print border-bottom d-block d-lg-none" app color="#f7f7f7" elevation="0">
				<div class="d-flex headerLogo">
					<div class="mt-1">
						<a @click="indexStore.navigateTo('/search')">
							<picture>
								<source
									media="(max-width: 1263px)"
									:srcset="infoObject.smallImg"
									height="45"
									alt="Waste Connections" />
								<!-- Mobile image -->
								<source
									media="(min-width: 1264px)"
									:srcset="infoObject.mediumImg"
									alt="Waste Connections" />
								<!-- Desktop image -->
								<img :src="infoObject.mediumImg" height="50" alt="Waste Connections" />
								<!-- Default -->
							</picture>
						</a>
					</div>
				</div>

				<div v-if="store.orgLogo.length > 0 && store.userInfo.isLogged" class="secondLogo">
					<picture class="pictureContainer">
						<source media="(max-width: 959px)" :srcset="store.orgLogo" />
						<!-- Mobile image -->
						<source media="(min-width: 960px)" :srcset="store.orgLogo" />
						<!-- Desktop image -->
						<img :src="store.orgLogo" class="logoImage" />
						<!-- Default -->
					</picture>
				</div>

				<v-app-bar-nav-icon
					v-ripple="false"
					x-large
					class="hidden-lg-and-up justify-start r-0 sidenav-btn"
					@click.stop="store.interfaceState.drawer = true" />

				<!-- Mobile Header -->
				<div
					v-if="store.interfaceState.drawer"
					class="custom-overlay"
					@click="store.interfaceState.drawer = false"></div>

				<!-- Removed -->
				<v-navigation-drawer
					v-if="false"
					v-model="store.interfaceState.drawer"
					app
					temporary
					hide-overlay
					left
					color="#f7f7f7"
					class="header-text text-left hidden-lg-and-up elevation-0"
					style="width: 85%; max-width: 400px">
					<div class="d-flex align-center justify-center mt-10">
						<v-btn-toggle v-model="i18n.locale" mandatory color="secondary" dense @change="changeLanguage">
							<v-btn
								value="en"
								:class="{ 'v-btn--active': i18n.locale == 'en' }"
								:disabled="store.interfaceState.loadingTab || store.interfaceState.loadingMain">
								EN
							</v-btn>
							<v-btn
								value="fr"
								:class="{ 'v-btn--active': i18n.locale == 'fr' }"
								:disabled="store.interfaceState.loadingTab || store.interfaceState.loadingMain">
								FR
							</v-btn>
						</v-btn-toggle>
					</div>

					<v-list class="pt-10">
						<v-list-group v-if="store.userInfo.isLogged" :value="false" no-action class="ml-n2">
							<template #activator>
								<v-list-item-icon class="mr-4">
									<v-icon>mdi-folder-table</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title class="subtitle-2">{{ $t('org') }}</v-list-item-title>
								</v-list-item-content>
							</template>

							<v-list-item class="ml-4" @click="indexStore.navigateTo('/search')">
								<v-list-item-content>
									<v-list-item-title class="subtitle-2">{{ $t('search') }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-group>

						<v-list-item v-if="store.isUserSuperUser" class="ml-n2">
							<v-list-item-icon class="mr-4">
								<v-icon>mdi-account-plus</v-icon>
							</v-list-item-icon>
							<v-list-item-content class="subtitle-2">
								<a @click="indexStore.navigateTo('/create-user')"> {{ $t('createUser') }} </a>
							</v-list-item-content>
						</v-list-item>

						<!-- Add Manage Customer Groups Menu -->
						<v-list-group
							v-if="store.userInfo.type == 'WCN Admin' && store.userInfo.isLogged"
							:value="false"
							no-action
							class="ml-n2">
							<template #activator>
								<v-list-item-icon class="mr-4">
									<v-icon>mdi-account-group</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title class="subtitle-2">{{ $t('manageGroups') }}</v-list-item-title>
								</v-list-item-content>
							</template>

							<v-list-item
								v-for="(item, index) in store.userInfo.manageCustomerOptions"
								:key="index"
								class="ml-4"
								@click="indexStore.navigateTo(item.link)">
								<v-list-item-content>
									<v-list-item-title class="subtitle-2">{{ item.title }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-group>

						<!-- Add Manage Users Menu -->
						<v-list-group
							v-if="
								(store.userInfo.type == 'WCN Admin' ||
									store.userInfo.type == 'WCN National Account Admin' ||
									store.userInfo.type == 'WCN National Account Manager' ||
									store.userInfo.type == 'WCN District Manager' ||
									store.userInfo.type == 'External Admin') &&
								store.userInfo.isLogged
							"
							:value="false"
							no-action
							class="ml-n2">
							<template #activator>
								<v-list-item-icon class="mr-4">
									<v-icon>mdi-account-cog</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title class="subtitle-2">{{ $t('manageUsers') }}</v-list-item-title>
								</v-list-item-content>
							</template>

							<v-list-item
								v-for="(item, index) in store.userInfo.manageUserOptions"
								:key="index"
								class="ml-4"
								@click="indexStore.navigateTo(item.link)">
								<v-list-item-content>
									<v-list-item-title class="subtitle-2">{{ item.title }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-group>

						<v-list-item v-if="store.countryVersion != 'CAN'" class="ml-n2">
							<v-list-item-icon class="mr-4">
								<v-icon>mdi-inbox-arrow-down</v-icon>
							</v-list-item-icon>
							<v-list-item-content class="subtitle-2">
								<a @click="indexStore.navigateTo('/export-requests')"> {{ $t('exportRequests') }} </a>
							</v-list-item-content>
						</v-list-item>

						<v-list-group v-if="store.userInfo.isLogged" :value="false" no-action class="ml-n2">
							<template #activator>
								<v-list-item-icon class="mr-4">
									<v-icon>mdi-account</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title class="subtitle-2">{{ $t('account') }}</v-list-item-title>
								</v-list-item-content>
							</template>

							<v-list-item :to="'/login'" class="ml-4" @click="logUserOut">
								<v-list-item-content>
									<v-list-item-title class="subtitle-2">{{ $t('logout') }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-group>
					</v-list>
				</v-navigation-drawer>
			</v-app-bar>

			<!-- Navigation Bar Desktop -->
			<div v-show="$vuetify.breakpoint.lgAndUp || store.interfaceState.drawer" class="navigation-bar-wrapper">
				<div class="navigation-bar override-menu-color d-flex flex-column justify-space-between">
					<div>
						<div class="text-end d-block d-lg-none pa-1">
							<v-btn icon @click="store.interfaceState.drawer = false">
								<v-icon color="white">mdi-close</v-icon>
							</v-btn>
						</div>
						<div class="d-flex justify-center">
							<div class="mt-0 mt-lg-6">
								<a @click="indexStore.navigateTo('/search')">
									<picture>
										<source
											media="(min-width: 960px)"
											:srcset="infoObject.mediumImg"
											alt="Waste Connections" />
										<!-- Desktop image -->
										<img :src="infoObject.mediumImg" height="145" alt="Waste Connections" />
									</picture>
								</a>
							</div>
						</div>

						<v-list class="transparent white-text-list text-left mt-10">
							<v-list-item v-if="store.userInfo.isLogged" @click="indexStore.navigateTo('/search')">
								<v-list-item-icon class="mr-4">
									<v-icon>mdi-folder-table</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title class="subtitle-2">{{ $t('Accounts') }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>

							<!-- Add Manage Customer Groups Menu -->
							<v-list-group
								v-if="store.userInfo.type == 'WCN Admin' && store.userInfo.isLogged"
								:value="false"
								no-action>
								<template #activator>
									<v-list-item-icon class="mr-4">
										<v-icon>mdi-account-group</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title class="subtitle-2">{{
											$t('manageGroups')
										}}</v-list-item-title>
									</v-list-item-content>
								</template>

								<v-list-item
									v-for="(item, index) in store.userInfo.manageCustomerOptions"
									:key="index"
									@click="indexStore.navigateTo(item.link)">
									<v-list-item-content>
										<v-list-item-title class="subtitle-2">{{ item.title }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list-group>

							<!-- Add Manage Users Menu -->
							<v-list-group
								v-if="
									(store.userInfo.type == 'WCN Admin' ||
										store.userInfo.type == 'WCN National Account Admin' ||
										store.userInfo.type == 'WCN National Account Manager' ||
										store.userInfo.type == 'WCN District Manager' ||
										store.userInfo.type == 'External Admin') &&
									store.userInfo.isLogged
								"
								:value="false"
								no-action>
								<template #activator>
									<v-list-item-icon class="mr-4">
										<v-icon>mdi-account-cog</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title class="subtitle-2">{{
											$t('manageUsers')
										}}</v-list-item-title>
									</v-list-item-content>
								</template>

								<v-list-item
									v-for="(item, index) in store.userInfo.manageUserOptions"
									:key="index"
									@click="indexStore.navigateTo(item.link)">
									<v-list-item-content>
										<v-list-item-title class="subtitle-2">{{ item.title }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list-group>

							<!-- logout -->
							<v-list-item v-if="store.userInfo.isLogged" :to="'/login'" @click="logUserOut">
								<v-list-item-icon class="mr-4">
									<v-icon>mdi-logout</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title class="subtitle-2">{{ $t('logout') }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>

							<!-- Help / Guide Tour -->
							<v-fade-transition>
								<v-list-item
									v-show="
										store.driverSteps.value.length > 0 &&
										!store.interfaceState.loadingTab &&
										!store.interfaceState.loadingMain
									"
									class="mb-5"
									@click="store.showDriver()">
									<v-list-item-icon :class="{ 'ml-6': !store.userInfo.isLogged, 'mr-4': true }">
										<v-icon>mdi-lightbulb-question</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title class="subtitle-2">{{ $t('pageTour') }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-fade-transition>
						</v-list>
					</div>

					<div class="d-flex justify-center custom mb-6">
						<v-btn-toggle
							v-model="i18n.locale"
							class="font-weight-light"
							mandatory
							color="secondary"
							dense
							@change="changeLanguage">
							<v-btn
								value="en"
								:class="{ 'v-btn--active': i18n.locale == 'en', 'font-weight-regular': true }"
								class="rounded-left"
								:disabled="store.interfaceState.loadingTab || store.interfaceState.loadingMain">
								EN
							</v-btn>
							<v-btn
								value="fr"
								:class="{ 'v-btn--active': i18n.locale == 'fr', 'font-weight-regular': true }"
								class="rounded-right"
								:disabled="store.interfaceState.loadingTab || store.interfaceState.loadingMain">
								FR
							</v-btn>
						</v-btn-toggle>
					</div>
				</div>
			</div>

			<div class="d-flex flex-column flex-grow-1" style="min-width: 0">
				<!-- Current Page -->
				<v-main class="body-background">
					<div id="mainView">
						<router-view :key="$route.fullPath" />
					</div>
				</v-main>

				<!-- Footer -->
				<v-footer
					class="hidden-print footer footer-background drop-shadow d-flex justify-center justify-sm-end">
					{{ $t('footerTitle') }} Copyright&nbsp;©&nbsp;{{ new Date().getFullYear() }}
					<!-- <div class="red--text ml-2">Breakpoint Size: {{ $vuetify.breakpoint.name }}</div> -->
				</v-footer>
			</div>
		</div>

		<DialogBox />
	</v-app>
</template>

<script setup>
	import DialogBox from '@/components/DialogBox.vue'
	import i18n from '@/i18n'
	import { auth } from '@/plugins/firebaseClient'
	import { useAuthStore } from '@/stores/auth'
	import { useIndexStore } from '@/stores/index'
	import { useUserStore } from '@/stores/user'
	import { onMounted, reactive } from 'vue'
	import { useGeneralities } from '../src/composables/generalities'

	// ------------------------------------------------
	// Reactive State

	const infoObject = reactive({
		enviroMobile:
			'https://firebasestorage.googleapis.com/v0/b/wcc-national-account-prod.firebasestorage.app/o/enviro-logo-mobile.svg?alt=media&token=ac09ecc8-a9bf-40e4-8247-7d29f385fda2',
		enviroDesktop:
			'https://firebasestorage.googleapis.com/v0/b/wcc-national-account-prod.firebasestorage.app/o/enviro-logo-desktop-white.png?alt=media&token=0840ecee-3fe3-4711-84b4-f62c7e6ca715',
		canadaMobile:
			'https://firebasestorage.googleapis.com/v0/b/wcc-national-account-prod.firebasestorage.app/o/wcc-logo-mobile.svg?alt=media&token=9defa807-e8f4-41b1-aed2-66e162b9077a',
		canadaDesktop:
			'https://firebasestorage.googleapis.com/v0/b/wcc-national-account-prod.firebasestorage.app/o/wcc-logo-desktop-white.png?alt=media&token=e7e7cac1-d0eb-446f-bec5-c9bdffe533ce',
		smallImg: '',
		mediumImg: '',
		bigImg: '',
		footerTitle: '',
		siteTitle: '',
		urlLink: '',
	})

	// ------------------------------------------------
	// Access the store
	const store = useUserStore()
	const authStore = useAuthStore()
	const indexStore = useIndexStore()
	const generalities = useGeneralities()

	// ------------------------------------------------
	// Methods

	// Log the user out of the application.
	const logUserOut = async () => {
		try {
			await authStore.logout(auth)
			store.interfaceState.drawer = false
		} catch (error) {
			generalities.openDialogBox('An error occurred while signing out', 'Error', 'OK', 'error')
			console.error('Error signing out:', error)
		}
	}

	// Load country-specific information into infoObject based on the country version.
	const loadCountryInfo = () => {
		if (store.countryVersion === 'CAN') {
			infoObject.smallImg = infoObject.canadaMobile
			infoObject.mediumImg = infoObject.canadaDesktop
			infoObject.bigImg =
				'https://dpbvj4a9anukr.cloudfront.net/c7941b0f-f427-4ef4-b63d-c0edd6af5e90/72c0e820-2804-483a-bdca-f8546d9e60a9/5efea414ff24e18bb3dfc7244a69ed8b/wc-logo-img.png'
			//infoObject.footerTitle = i18n.t('footerTitle')
			infoObject.siteTitle = 'Waste Connections Canada - National Account Portal'
			infoObject.urlLink = 'https://www.wasteconnectionscanada.com/'
		} else {
			infoObject.smallImg = 'https://www.smartsoftdq.com/wp-content/uploads/2017/04/WC-300x300.png'
			infoObject.mediumImg =
				'https://d16bl9hbknyxy0.cloudfront.net/c7941b0f-f427-4ef4-b63d-c0edd6af5e90/9330d04b-5764-4aaf-9e5e-d1e6cd9543bd/wci-brand-signature-3-color-horizontal.png?w=2400&h=2400&fit=inside&Expires=9223372036854775&Signature=iDpQU1FUHbwMYdp7v33j-4EDC0ixkiJT~Whbo~CmpJp76aeym-GTPkUL3lnM1TQQkSnH5WuobABi4oG-~e-2JT1m0zWfOwR~r3Dvv94gmI1fsxO6sLT2PaVW3wwUWnyqi9J~yCvvIBdu1pjz1fy6BIvQ3eau2azN-DK2UqNpJbMZUAyRWefNaJHFTYcbnN3Uj2K6gzAa3z1JWZKPtqfVwUki2bOO7mFAz2xIEnmniYtU263kP4wX4qLqX8yV~Rl19JlceaKbl6MOEst4WhgU4xLOZq-jpzOWPTg6ZtRawSfXo8ZG1ag-Jp~ndN4d1Gtka7SnxNJxDeX6a2sGx-8Q__&Key-Pair-Id=K2SKI2Y48Y62V1'
			infoObject.bigImg =
				'https://d16bl9hbknyxy0.cloudfront.net/c7941b0f-f427-4ef4-b63d-c0edd6af5e90/9330d04b-5764-4aaf-9e5e-d1e6cd9543bd/wci-brand-signature-3-color-horizontal.png?w=2400&h=2400&fit=inside&Expires=9223372036854775&Signature=iDpQU1FUHbwMYdp7v33j-4EDC0ixkiJT~Whbo~CmpJp76aeym-GTPkUL3lnM1TQQkSnH5WuobABi4oG-~e-2JT1m0zWfOwR~r3Dvv94gmI1fsxO6sLT2PaVW3wwUWnyqi9J~yCvvIBdu1pjz1fy6BIvQ3eau2azN-DK2UqNpJbMZUAyRWefNaJHFTYcbnN3Uj2K6gzAa3z1JWZKPtqfVwUki2bOO7mFAz2xIEnmniYtU263kP4wX4qLqX8yV~Rl19JlceaKbl6MOEst4WhgU4xLOZq-jpzOWPTg6ZtRawSfXo8ZG1ag-Jp~ndN4d1Gtka7SnxNJxDeX6a2sGx-8Q__&Key-Pair-Id=K2SKI2Y48Y62V1'
			infoObject.footerTitle = 'Waste Connections'
			infoObject.siteTitle = 'Diversion Portal - Waste Connections Canada'
			infoObject.urlLink = 'https://www.wasteconnections.com/'
		}
	}

	// force stuborn text to update
	const changeLanguage = () => {
		// store in browser
		localStorage.setItem('user-lang', i18n.locale)

		// change logos
		infoObject.smallImg = i18n.locale == 'en' ? infoObject.canadaMobile : infoObject.enviroMobile
		infoObject.mediumImg = i18n.locale == 'en' ? infoObject.canadaDesktop : infoObject.enviroDesktop

		// Adjust guide buttons
		store.driverObj.setConfig({
			nextBtnText: i18n.t('next'),
			prevBtnText: i18n.t('previous'),
			doneBtnText: i18n.t('done'),
			showProgress: true,
		})

		// This block should be in a function, avoid repeating code, see Auth Store initializeCanadianUser()
		let manageUserOptions = []
		if (
			[
				'WCN Admin',
				'WCN National Account Admin',
				'WCN National Account Manager',
				'WCN District Manager',
				'External Admin',
			].includes(store.userInfo.type)
		) {
			manageUserOptions = [
				{ title: i18n.t('create'), link: '/create-user' },
				{ title: i18n.t('update'), link: '/update-user/false/false' },
				{ title: i18n.t('copy'), link: '/copy-transfer-user/copy/false/false' },
				{ title: i18n.t('transfer'), link: '/copy-transfer-user/transfer/false/false' },
			]
			if (store.userInfo.type === 'WCN Admin') {
				manageUserOptions.push({ title: i18n.t('delete'), link: '/DeleteUser/false/false' })
			}
		}
		store.userInfo.manageUserOptions = manageUserOptions
		store.setManageCustomerOptions()
	}

	// ------------------------------------------------
	// Lifecycle
	onMounted(() => {
		loadCountryInfo()
		store.setManageCustomerOptions()

		// Gets stored language
		const lang = localStorage.getItem('user-lang')
		if (lang == 'fr' || lang == 'en') {
			i18n.locale = lang
			changeLanguage()
		}
	})
</script>

<style scoped>
	.white-text-list,
	.white-text-list .v-list-item__title,
	::v-deep .white-text-list .v-list-item__icon .v-icon {
		color: rgb(240, 240, 240) !important;
	}
	.white-text-list,
	.white-text-list .v-list-item__title {
		font-weight: 300;
		font-size: 15px !important;
	}
	::v-deep .white-text-list .v-list-item {
		padding: 0 40px;
	}
	::v-deep .white-text-list .v-list-group .v-list-group__header .v-list-item__icon {
		margin-left: 0;
	}

	.footer {
		border-top: 2px solid #e8ebea;
		padding: 11px 60px 19px 0px;
		text-align: right;
		color: rgb(143, 143, 143);
		font-size: 12px;
		font-weight: 500;
	}

	@media only screen and (max-width: 600px) {
		.footer {
			padding: 12px;
			text-align: center;
		}
	}

	.v-list-item--link {
		padding-top: 4px !important;
		padding-bottom: 4px !important;
	}
	.border-bottom {
		border-bottom: 2px solid #e8ebea !important;
	}
	/* ::v-deep .v-overlay {
		z-index: 5 !important;
	} */
	.v-app-bar__nav-icon.v-btn:hover::before {
		opacity: 0 !important;
	}

	.custom-overlay {
		height: 100vh;
		width: 100vw;
		position: fixed;
		top: 0;
		left: 0;
		opacity: 0.66;
		background-color: rgb(33, 33, 33);
	}

	.navigation-bar {
		width: 280px;
		height: 100%;
		position: fixed;
		/* background: linear-gradient(to bottom, #1f2430, #343a4c); */
		background-color: var(--v-secondary-base);
		overflow-y: auto;
	}

	.navigation-bar-wrapper {
		height: 100vh;
		width: 280px;
		z-index: 10;
		flex-shrink: 0;
	}

	@media only screen and (max-width: 1264px) {
		.navigation-bar-wrapper {
			width: 0;
		}
	}

	::v-deep .custom .v-btn--has-bg {
		background-color: transparent !important;
		color: white !important;
	}

	::v-deep .custom .v-btn-toggle:not(.v-btn-toggle--group) {
		background: transparent !important;
	}

	::v-deep .custom .v-btn-toggle:not(.v-btn-toggle--group) .v-btn {
		border-color: rgb(163, 163, 163) !important;
	}

	.v-application .primary--text {
		color: white !important;
	}

	::v-deep .remove-underpart .v-text-field__details {
		display: none;
	}

	::v-deep .remove-underpart .v-input__slot {
		margin-bottom: 0 !important;
		/* box-shadow: none !important; */
	}

	.rounded-left {
		border-top-left-radius: 16px !important;
		border-bottom-left-radius: 16px !important;
	}

	.rounded-right {
		border-top-right-radius: 16px !important;
		border-bottom-right-radius: 16px !important;
	}

	@media only print {
		.hidden-print {
			display: none !important;
		}

		.body-background {
			background-color: white !important;
		}
	}
</style>
